import groq from 'groq';

import { BANNER_MEDIA } from './banner';

export const CERTIFICATION_BANNER = groq`
  _type,
  title,
  media[0] {
    ${BANNER_MEDIA}
  },
  description,
  logos[]{
    label,
    logo{
      alt,
      asset -> {
        url
      }
    }
  }
`;

export const CERTIFICATION_BLOCK = groq`
  _type == 'certifications' => @-> {
    ${CERTIFICATION_BANNER}
  }
`;
